import { Observable } from 'rxjs';

export enum UploadEventType {
  Start,
  Progress,
  Done,
  Error,
  Abort
}

export interface UploadEvent {
  type: UploadEventType;
  data?: any;
}

export interface SignedFormLike {
  url: string;
  fields: { [key: string]: string };
}

export type FuncVoid = () => void;

export interface S3Upload {
  send: () => Observable<UploadEvent>;
  abort: FuncVoid;
}

/**
 * Envia o arquivo direto ao S3 usando o formulário pré-assinado devolvido
 * pelo backend. Os bytes não passam pelo servidor.
 */
export const CreateS3Upload = (signedForm: SignedFormLike, file: File): S3Upload => {
  const postData = new FormData();
  postData.append('Content-Type', signedForm.fields['Content-Type']);
  postData.append('key', signedForm.fields['key']);
  postData.append('x-amz-algorithm', signedForm.fields['x-amz-algorithm']);
  postData.append('x-amz-credential', signedForm.fields['x-amz-credential']);
  postData.append('x-amz-date', signedForm.fields['x-amz-date']);
  postData.append('policy', signedForm.fields['policy']);
  postData.append('x-amz-signature', signedForm.fields['x-amz-signature']);
  postData.append('file', file);

  let xhr: XMLHttpRequest;
  let _progresso = null;

  return {
    send: (): Observable<UploadEvent> => {
      return new Observable<UploadEvent>(observer => {
        if (xhr) { return; }

        xhr = new XMLHttpRequest();
        xhr.open('POST', signedForm.url);

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status > 0) {
            if (xhr.status === 200 || xhr.status === 204) {
              observer.next({ type: UploadEventType.Done });
              observer.complete();
            } else {
              observer.next({ type: UploadEventType.Error });
              observer.complete();
            }
          }
        };

        xhr.upload.onprogress = function (event) {
          if (event['lengthComputable']) {
            const percentComplete = Math.round((event['loaded'] / event['total']) * 100);

            if (_progresso !== percentComplete) {
              _progresso = percentComplete;
              observer.next({ type: UploadEventType.Progress, data: `${percentComplete}%` });
            }
          }
        };

        xhr.onabort = function () {
          observer.next({ type: UploadEventType.Abort });
          observer.complete();
        };

        xhr.onerror = function () {
          console.log('error:', xhr);
          observer.next({ type: UploadEventType.Error });
          observer.complete();
        };

        xhr.send(postData);
        observer.next({ type: UploadEventType.Start });
      });
    },
    abort: () => {
      xhr.abort();
      xhr = null;
      _progresso = null;
    }
  };
};
